module.exports = __webpack_public_path__ + "static/media/ASC July 2020 Top Five_1592393687159.10373f4d.pptx";